module.exports = __webpack_public_path__ + "images/zuidwestleasebb2133b1448be5fafc0e484713aaa231.png";